export default {
  methods: {
    validate () {
      this.$v.value.$touch()
      return !this.$v.$anyError
    }
  },
  computed: {
    ready () {
      return !this.$v.value.$invalid
    },
    dirty () {
      return this.$v.value.$anyDirty
    }
  },
  watch: {
    ready (val) {
      this.$emit('ready', val)
    },
    dirty (val) {
      this.$emit('dirty', val)
    }
  }
}
